import React from 'react';

import styles from './styles.module.scss';
import {Hero} from './Hero';
import {Trusted} from './Trusted';
import {Glance} from './Glance';
import {Community} from './Community';
import {useStats} from '../../hooks/useStats';
import {Loader} from '../../components/Loader';

export const Home = () => {
  const {stats, loading} = useStats();

  if (loading) return <Loader />;

  return (
    <div className={styles.home}>
      <Hero />
      <Trusted stats={stats} />
      <Glance />
      <Community />
    </div>
  );
};
